import { config } from '@uhg-abyss/web/tools/config';

import { useCustomQuery } from '../useCustomQuery';
import GET_CARE_TEAM from './GetCareTeam.graphql';
import GET_CARE_TEAM_PAGINATED from './GetCareTeamPaginated.graphql';
import SAVE_CARE_TEAM from './SaveCareTeam.graphql';

export const useSaveCareTeam = (options) =>
  useCustomQuery(SAVE_CARE_TEAM, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'saveCareTeam',
    requestPolicy: 'no-cache',
  });

export const useGetCareTeam = (options) => {
  const [queryResult, queryAction] = useCustomQuery(GET_CARE_TEAM, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'getCareTeam',
    //TODO: Need to check if this is required or not
    requestPolicy: 'no-cache',
  });

  const parsedResult = {
    ...queryResult,
    data: {
      getCareTeam: {
        ...queryResult?.data?.getCareTeam,
        chipWithCount: queryResult?.data?.getCareTeam?.chipWithCount?.reduce(
          (acc, { chip, count }) => ({ ...acc, [chip]: count }),
          {}
        ),
      },
    },
  };

  return [parsedResult, queryAction];
};

export const useGetCareTeamPaginated = (options) => {
  const [queryResult, queryAction] = useCustomQuery(GET_CARE_TEAM_PAGINATED, {
    ...options,
    url: config('GRAPHQL_API_URL'),
    accessor: 'getCareTeamPaginated',
    requestPolicy: 'no-cache',
  });
  const parsedResult = {
    ...queryResult,
    data: {
      ...queryResult?.data?.getCareTeamPaginated,
    },
  };
  return [parsedResult, queryAction];
};
